import TextField from "@mui/material/TextField";
import React from "react";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
  root: {
    "&.MuiTextField-root": {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
  },
}));

export default ({ field, label, required, type, form, ...rest }) => {
  const classes = useStyles();

  let errorText = errorText;
  if (form.errors[field.name] && form.touched[field.name]) {
    errorText = form.errors[field.name];
  }
  return (
    <TextField
      className={classes.root}
      density="normal"
      label={label}
      type={type}
      required={required}
      fullWidth
      error={!!errorText}
      helperText={errorText}
      {...field}
    />
  );
};
